import { useQuery } from "@tanstack/react-query";
import { FileInterface } from "../../../types/RecordInterfaces";
import TenantAPI from "../../api/TenantAPI";
import _ from "underscore";

const fileExtensions: { [key: string]: string[] } = {
  Image: ["png", "jpg", "jpeg", "gif", "bmp", "svg"],
  Text: ["txt", "xml", "json"],
  Audio: ["wav", "mp3", "ogg", "acc"],
  Video: ["mp4", "ogv", "webm", "mpg", "mov", "flv"],
  PDF: ["pdf"],
};

const useFilePreview = (File: FileInterface) => {
  let publicURL = File?.PublicURL;

  const preview = useQuery({
    queryKey: ["file", File?.id],
    queryFn: () =>
      TenantAPI.getFileURL(File.File).then((data) => {
        return { Url: data.data.data.url, Type: type() };
      }),
    enabled: File ? true : false,
  });

  const getMimeType = () => {
    if (!File || !File.File || typeof File.File !== "string") return "";

    return File.File?.split?.(".")?.pop() ?? "";
  };

  function type() {
    const mimeType = getMimeType();
    const keys = _.keys(fileExtensions);
    let found;

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      fileExtensions[key].forEach((e: any) => {
        if (e === mimeType) {
          found = key;
          i = keys.length + 1;
        }
      });
    }
    return found || "Unknown";
  }

  return {
    fileSource: publicURL ? publicURL : (preview.data?.Url as string),
    loading: publicURL ? false : preview.isLoading,
    previewError: publicURL ? null : preview.error,
    fileType: publicURL ? type() : preview.data?.Type || "Unknown",
    extension: getMimeType(),
  };
};

export default useFilePreview;
